var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("FormulateInput", {
        attrs: {
          name: "taxes",
          type: "group",
          "error-behavior": "live",
          repeatable: true,
          "add-label": _vm.$t("Adicionar configuração"),
          limit: _vm.isStockLosses
            ? _vm.invoiceStockLossesReasonOptions().length
            : 1,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var index = ref.index
              return [
                _c(
                  "b-row",
                  [
                    _vm.isStockLosses
                      ? _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c("FormulateInput", {
                              class: { required: _vm.isStockLosses },
                              attrs: {
                                id: "tax-loss-reason-" + index,
                                name: "stockLossesReason",
                                type: "vue-select",
                                options: _vm.invoiceStockLossesReasonOptions(),
                                label: _vm.$t("Motivo baixa de estoque"),
                                title: _vm.$t("Selecione"),
                                validation: _vm.isStockLosses ? "required" : "",
                                clearable: false,
                                size: "5",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-st-ipi-" + index,
                            name: "stIpi",
                            type: "vue-select",
                            label: _vm.$t("Cst Ipi Saída"),
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.getComboCstIpiOutput,
                            validation: "required",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-ipi-percent-" + index,
                            name: "ipiPercent",
                            type: "text-percetage",
                            validation: "required|number|min:0",
                            label: _vm.$t("Alíquota Ipi"),
                            currency: "%",
                            precision: 4,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-st-pis-" + index,
                            name: "stPis",
                            type: "vue-select",
                            label: _vm.$t("Cst Pis Saída"),
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.getComboCstPisCofinsOutput,
                            validation: "required",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-pis-percent-" + index,
                            name: "pisPercent",
                            type: "text-percetage",
                            validation: "required|number",
                            label: _vm.$t("Alíquota Pis"),
                            currency: "%",
                            precision: 4,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-st-cofins-" + index,
                            name: "stCofins",
                            type: "vue-select",
                            label: _vm.$t("Cst Cofins Saída"),
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.getComboCstPisCofinsOutput,
                            validation: "required",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-cofins-percent-" + index,
                            name: "cofinsPercent",
                            type: "text-percetage",
                            validation: "required|number|min:0",
                            label: _vm.$t("Alíquota Cofins"),
                            currency: "%",
                            precision: 4,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "3" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-st-icms-" + index,
                            name: "stIcms",
                            type: "vue-select",
                            label: _vm.$t("Cst Icms"),
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.getComboCstIcms,
                            validation: "required",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-icms-csosn-" + index,
                            name: "csosnIcms",
                            type: "vue-select",
                            label: _vm.$t("Csosn Icms"),
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.getComboCsosnIcms,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-icms-percent-" + index,
                            name: "icmsPercent",
                            type: "text-percetage",
                            validation: "required|number|min:0",
                            currency: "%",
                            precision: 4,
                            label: _vm.$t("Alíquota Icms"),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-icmsBaseReduction-percent-" + index,
                            name: "icmsBaseReductionPercent",
                            type: "text-percetage",
                            label: _vm.$t("Redução Base Icms"),
                            validation: "required|number|min:0",
                            currency: "%",
                            precision: 4,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-icms-iva-" + index,
                            name: "iva",
                            type: "text-percetage",
                            label: _vm.$t("Iva"),
                            validation: "required|number|min:0",
                            currency: "%",
                            precision: 4,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-icms-st-percent-" + index,
                            name: "icmsStPercent",
                            type: "text-percetage",
                            label: _vm.$t("Alíquota Icms ST"),
                            validation: "required|number|min:0",
                            currency: "%",
                            precision: 4,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-icms-st-base-reduction-percent-" + index,
                            name: "icmsStBaseReductionPercent",
                            type: "text-percetage",
                            label: _vm.$t("Redução Base Icms ST"),
                            validation: "required|number|min:0",
                            currency: "%",
                            precision: 4,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "3" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-icms-fcp-percent-" + index,
                            name: "fcpPercent",
                            type: "text-percetage",
                            label: _vm.$t(
                              "Alíquota Fundo de Combate à Pobreza"
                            ),
                            validation: "required|number|min:0",
                            currency: "%",
                            precision: 4,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "3" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "tax-icms-fcp-st-percent-" + index,
                            name: "fcpStPercent",
                            type: "text-percetage",
                            label: _vm.$t(
                              "Alíquota Fundo de Combate à Pobreza ST"
                            ),
                            validation: "required|number|min:0",
                            currency: "%",
                            precision: 4,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("hr", { staticClass: "my-2" }),
                _c("h6", { staticClass: "mb-1" }, [
                  _vm._v(" " + _vm._s(_vm.$t("Informações Gerais")) + " "),
                ]),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-st-cbs-ibs-" + index,
                            name: "stCbsIbsCode",
                            type: "vue-select",
                            options: _vm.comboCstCbsIbs,
                            placeholder: _vm.$t("Selecione"),
                            label: _vm.$t("Situação Trib. CBS/IBS"),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "8" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-fiscal-classification-cbs-ibs-" + index,
                            name: "fiscalClassificationCbsIbsCode",
                            type: "vue-select",
                            placeholder: _vm.$t("Selecione"),
                            disabled: !_vm.getTaxStCbsIbsCode(index),
                            options: _vm.getComboFiscalClassification(
                              _vm.getTaxStCbsIbsCode(index)
                            ),
                            label: _vm.$t("Classificação CBS/IBS"),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("h6", { staticClass: "mb-1 mt-1" }, [
                  _vm._v(" " + _vm._s(_vm.$t("CBS")) + " "),
                ]),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-cbs-percent-" + index,
                            name: "cbsPercent",
                            type: "text-percetage",
                            currency: "%",
                            precision: 5,
                            label: _vm.$t("Alíquota CBS (%)"),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-cbs-reduction-percent-" + index,
                            name: "cbsReductionPercent",
                            type: "text-percetage",
                            currency: "%",
                            precision: 5,
                            label: _vm.$t("Redução CBS (%)"),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-cbs-deferral-percent-" + index,
                            name: "cbsDeferralPercent",
                            type: "text-percetage",
                            currency: "%",
                            precision: 5,
                            label: _vm.$t("Diferimento CBS (%)"),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("h6", { staticClass: "mb-1 mt-1" }, [
                  _vm._v(" " + _vm._s(_vm.$t("IBS")) + " "),
                ]),
                _c("p", { staticClass: "mb-1" }, [
                  _vm._v(" " + _vm._s(_vm.$t("IBS Estadual")) + " "),
                ]),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-ibs-state-percent-" + index,
                            name: "ibsStatePercent",
                            type: "text-percetage",
                            currency: "%",
                            precision: 5,
                            label: _vm.$t("Alíquota IBS Estado (%)"),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-ibs-state-reduction-percent-" + index,
                            name: "ibsStateReductionPercent",
                            type: "text-percetage",
                            currency: "%",
                            precision: 5,
                            label: _vm.$t("Redução IBS Estado (%)"),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-ibs-state-deferral-percent-" + index,
                            name: "ibsStateDeferralPercent",
                            type: "text-percetage",
                            currency: "%",
                            precision: 5,
                            label: _vm.$t("Diferimento IBS Estado (%)"),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("p", { staticClass: "mb-1 mt-1" }, [
                  _vm._v(" " + _vm._s(_vm.$t("IBS Municipal")) + " "),
                ]),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-ibs-municipal-percent-" + index,
                            name: "ibsMunicipalPercent",
                            type: "text-percetage",
                            currency: "%",
                            precision: 5,
                            label: _vm.$t("Alíquota IBS Município (%)"),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-ibs-municipal-reduction-percent-" + index,
                            name: "ibsMunicipalReductionPercent",
                            type: "text-percetage",
                            currency: "%",
                            precision: 5,
                            label: _vm.$t("Redução IBS Município (%)"),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-ibs-municipal-deferral-percent-" + index,
                            name: "ibsMunicipalDeferralPercent",
                            type: "text-percetage",
                            currency: "%",
                            precision: 5,
                            label: _vm.$t("Diferimento IBS Município (%)"),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("hr", { staticClass: "my-2" }),
                _c("h6", { staticClass: "mb-1" }, [
                  _vm._v(" " + _vm._s(_vm.$t("Imposto Seletivo")) + " "),
                ]),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "3" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-selective-tax-st-" + index,
                            name: "stSelectiveTaxCode",
                            type: "vue-select",
                            options: _vm.comboCstCbsIbs,
                            placeholder: _vm.$t("Selecione"),
                            label: _vm.$t("Situação Trib. Imposto Seletivo"),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "3" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-selective-tax-classification-" + index,
                            name: "fiscalClassificationSelectiveTaxCode",
                            type: "vue-select",
                            placeholder: _vm.$t("Selecione"),
                            disabled: !_vm.getTaxStSelectiveTaxCode(index),
                            options: _vm.getComboSelectiveClassification(
                              _vm.getTaxStSelectiveTaxCode(index)
                            ),
                            label: _vm.$t("Classificação Imposto Seletivo"),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-selective-tax-type-" + index,
                            name: "selectiveTaxType",
                            type: "vue-select",
                            options: _vm.comboSelectiveTaxTypes,
                            placeholder: _vm.$t("Selecione"),
                            label: _vm.$t("Tipo Imposto Seletivo"),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-selective-tax-percent-" + index,
                            name: "selectiveTaxPercent",
                            type: "text-percetage",
                            currency: "%",
                            precision: 4,
                            label: _vm.$t("% Imposto Seletivo"),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "2" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "tax-selective-tax-value-per-unit-" + index,
                            name: "selectiveTaxValuePerUnit",
                            type: "text-percetage",
                            currency: "R$",
                            precision: 4,
                            label: _vm.$t("Valor por Unidade"),
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-row",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            name: "benefitCodes",
                            type: "group",
                            repeatable: true,
                            "add-label": _vm.$t("Adicionar cBenef por UF"),
                            label: _vm.$t(
                              "Código do Benefício Fiscal (cBenef)"
                            ),
                            instruction: _vm.$t(
                              "Código do benefício fiscal usado nos itens da nota quando esse CFOP for escolhido como natureza da operação. É usado o código da UF da loja emitente, ou seja, quando a UF não tiver um código informado o campo fica em branco na nota."
                            ),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var benefitCodeIndex = ref.index
                                  return [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { md: "3" } },
                                          [
                                            _c("FormulateInput", {
                                              staticClass: "required",
                                              attrs: {
                                                id:
                                                  "tax-benefit-code-province-" +
                                                  index +
                                                  "-" +
                                                  benefitCodeIndex,
                                                name: "province",
                                                type: "vue-select",
                                                options: _vm.comboProvinces,
                                                placeholder:
                                                  _vm.$t("Selecione"),
                                                label: _vm.$t("UF"),
                                                validation: "required",
                                                clearable: false,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "3" } },
                                          [
                                            _c("FormulateInput", {
                                              staticClass: "required",
                                              attrs: {
                                                id:
                                                  "tax-benefit-code-" +
                                                  index +
                                                  "-" +
                                                  benefitCodeIndex,
                                                name: "code",
                                                type: "text",
                                                label: _vm.$t("cBenef"),
                                                validation: "required",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-row",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            name: "additionalInformation",
                            type: "group",
                            repeatable: true,
                            "add-label": _vm.$t("Adicionar texto por UF"),
                            label: _vm.$t("Dados adicionais da nota"),
                            instruction: _vm.$t(
                              "Texto preenchido automaticamente nas informações adicionais da nota quando esse CFOP for escolhido como natureza da operação. É usado o texto da UF da loja emitente e, quando ela não tiver um texto próprio, o texto padrão. Na nota o texto continua editável."
                            ),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var additionalInformationIndex = ref.index
                                  return [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { md: "3" } },
                                          [
                                            _c("FormulateInput", {
                                              staticClass: "required",
                                              attrs: {
                                                id:
                                                  "tax-additional-information-province-" +
                                                  index +
                                                  "-" +
                                                  additionalInformationIndex,
                                                name: "province",
                                                type: "vue-select",
                                                options:
                                                  _vm.comboAdditionalInformationProvinces,
                                                placeholder:
                                                  _vm.$t("Selecione"),
                                                label: _vm.$t("UF"),
                                                validation: "required",
                                                clearable: false,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "9" } },
                                          [
                                            _c("FormulateInput", {
                                              staticClass: "required",
                                              attrs: {
                                                id:
                                                  "tax-additional-information-text-" +
                                                  index +
                                                  "-" +
                                                  additionalInformationIndex,
                                                name: "text",
                                                type: "textarea",
                                                label: _vm.$t("Texto"),
                                                validation: "required",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.taxes,
          callback: function ($$v) {
            _vm.taxes = $$v
          },
          expression: "taxes",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }